module.exports = __webpack_public_path__ + "cf96a7851eec864479df2c11c60afb85.jpg";